module.exports = __webpack_public_path__ + "img/GLT-LOGISTICS-(TRADEMARK).b5c7342f.png";